var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "main-head", class: { "opacity-all": _vm.isHome } },
    [
      _c(
        "flex",
        {
          staticClass: "menu-wrapper",
          attrs: { align: "center", justify: "between" },
        },
        [
          _c(
            "flex",
            { staticClass: "menu-tab-wrapper", attrs: { align: "center" } },
            [
              _c("img", {
                staticClass: "logo-img",
                attrs: { src: require("@/static/img/logo.png"), alt: "logo" },
                on: {
                  click: function ($event) {
                    return _vm.$router.push("/home")
                  },
                },
              }),
              _vm._v(" "),
              _vm._l(_vm.menueList, function (item, index) {
                return _c(
                  "a",
                  {
                    key: index,
                    staticClass: "menu-item",
                    on: {
                      click: function ($event) {
                        return _vm.toPath(item)
                      },
                    },
                  },
                  [_vm._v("\n        " + _vm._s(item.name) + "\n      ")]
                )
              }),
            ],
            2
          ),
          _vm._v(" "),
          _vm.showSearch
            ? _c(
                "div",
                { staticClass: "search-box" },
                [
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.keyword,
                        expression: "keyword",
                      },
                    ],
                    staticClass: "search-input",
                    attrs: { placeholder: "请输入关键词" },
                    domProps: { value: _vm.keyword },
                    on: {
                      keyup: function ($event) {
                        if (
                          !$event.type.indexOf("key") &&
                          _vm._k(
                            $event.keyCode,
                            "enter",
                            13,
                            $event.key,
                            "Enter"
                          )
                        )
                          return null
                        return _vm.searchByKeyword.apply(null, arguments)
                      },
                      input: function ($event) {
                        if ($event.target.composing) return
                        _vm.keyword = $event.target.value
                      },
                    },
                  }),
                  _vm._v(" "),
                  _c(
                    "flex",
                    {
                      staticClass: "search-buttons",
                      attrs: { align: "center" },
                    },
                    [
                      _c(
                        "el-popover",
                        {
                          attrs: { placement: "bottom" },
                          model: {
                            value: _vm.imageUploadVisible,
                            callback: function ($$v) {
                              _vm.imageUploadVisible = $$v
                            },
                            expression: "imageUploadVisible",
                          },
                        },
                        [
                          _c("search-image-uploader"),
                          _vm._v(" "),
                          _c(
                            "flex",
                            {
                              attrs: { slot: "reference", align: "center" },
                              slot: "reference",
                            },
                            [
                              _c("img", {
                                staticStyle: { height: "22px" },
                                attrs: {
                                  src: require("@/static/img/searchByImage-black.png"),
                                },
                              }),
                            ]
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c("img", {
                        staticStyle: { height: "20px" },
                        attrs: {
                          src: require("@/static/img/search-icon-circle-black.png"),
                        },
                        on: {
                          click: function ($event) {
                            return _vm.searchByKeyword(_vm.keyword)
                          },
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _c(
            "flex",
            { staticClass: "user-box", attrs: { align: "center" } },
            [
              _c(
                "el-button",
                {
                  staticStyle: { height: "32px", "line-height": "0px" },
                  attrs: { type: "primary" },
                  on: {
                    click: function ($event) {
                      return _vm.$router.push("/image-search")
                    },
                  },
                },
                [_vm._v("\n        立即购买\n      ")]
              ),
              _vm._v(" "),
              _c(
                "flex",
                {
                  staticClass: "menu-item option-item",
                  attrs: { align: "center" },
                  on: { click: _vm.toPersonCenter },
                },
                [
                  _c("img", {
                    attrs: {
                      src: require("@/static/img/home/gongtu-black.png"),
                    },
                  }),
                  _vm._v("\n        供图\n      "),
                ]
              ),
              _vm._v(" "),
              _vm.userInfo.user_id
                ? _c(
                    "el-popover",
                    {
                      attrs: {
                        placement: "bottom",
                        width: "100px",
                        trigger: "hover",
                      },
                    },
                    [
                      _c(
                        "div",
                        { staticClass: "user-options" },
                        _vm._l(_vm.userOptionsByFilter, function (item, index) {
                          return _c(
                            "flex",
                            {
                              key: index,
                              staticClass: "options-item",
                              attrs: { align: "center" },
                              on: {
                                click: function ($event) {
                                  return _vm.handleUserOption(item)
                                },
                              },
                            },
                            [
                              _c("svg-icon", {
                                staticClass: "user-icon",
                                attrs: { "icon-class": item.icon },
                              }),
                              _vm._v(" "),
                              _c("span", [_vm._v(_vm._s(item.name))]),
                            ],
                            1
                          )
                        }),
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "span",
                        {
                          staticClass: "menu-item option-item",
                          attrs: { slot: "reference" },
                          slot: "reference",
                        },
                        [
                          _vm._v(
                            "\n          " +
                              _vm._s(_vm.userInfo.nick_name) +
                              "\n        "
                          ),
                        ]
                      ),
                    ]
                  )
                : _c(
                    "a",
                    { staticClass: "option-item", on: { click: _vm.login } },
                    [_vm._v("\n        注册/登录\n      ")]
                  ),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "main-dialog",
        {
          attrs: {
            visible: _vm.visible,
            "close-on-modal": false,
            "comm-class": "no-header",
            width: "450px",
            top: "22vh",
          },
          on: {
            "update:visible": function ($event) {
              _vm.visible = $event
            },
          },
        },
        [
          _c("login", {
            attrs: { "bound-weixin-status": _vm.boundWeixinStatus },
            on: { close: _vm.handleClose, finish: _vm.finishLogin },
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }